import React from "react";

const Root = ({ children }) => {
  return (
    <div className="mx-4 flex justify-center">
      <div className="container mx-auto xl:max-w-[1140px]">{children}</div>
    </div>
  );
};

export default Root;
